import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule } from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import useTrainingModule from '@hooks/useTrainingModule'

import TrainingModuleImageItem from './TrainingModuleImageItem/index'

interface TrainingModulePayloadImageProps {
  trainingModulePayload: ReturnType<typeof useTrainingModule>,
}

const TrainingModuleImage = (props: TrainingModulePayloadImageProps) => {
  const { trainingModulePayload } = props
  const { loading, trainingModule } = trainingModulePayload

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: trainingModule.id,
      attachable_type: 'TrainingModule',
      attachment_type: 'module_image',
    },
    performHttpRequests: !!trainingModule.id,
  })

  const { filteredAttachments } = attachmentsPayload
  const trainingModuleImage = filteredAttachments[0]
    || { attachable_id: trainingModule.id, attachable_type: 'TrainingModule', attachment_type: 'module_image' }

  const trainingModuleImageUrl = digObject(trainingModuleImage, 'links.thumb_url')
  const { file_file_name } = trainingModuleImage

  const {
    callbacks: {
      createOrEditAttachment,
    },
  } = useAttachment(trainingModuleImage)

  return (
    <DashboardModule loading={loading} title="Image">
      {!loading && (
        <TrainingModuleImageItem
          callbacks={{
            launchModalFn: createOrEditAttachment,
          }}
          fileName={file_file_name}
          imageUrl={trainingModuleImageUrl}
        />
      )}
    </DashboardModule>
  )
}

export default TrainingModuleImage
